import $ from "jquery"

/** @type {(el: HTMLElement | null) => void} */
export const setMoveTopHandler = el => {
  if (!el) {
    console.warn("top anchor element is not found.")
    return
  }
  el.addEventListener("click", e => {
    e.preventDefault()
    $("html,body").animate({ scrollTop: 0 }, "slow")
  })
}
